import { useState } from 'react'
import { createContainer } from 'unstated-next'

const useStickyState = function (currentStickyState = false) {
  let [ isStickyInEffect, setIsStickyInEffect ] = useState(currentStickyState)
  return { isStickyInEffect, setIsStickyInEffect }
}
const FormVisualStateContainer = createContainer(useStickyState)

export default FormVisualStateContainer
